import type { AddedAssetTheme } from 'fym-shared/src/music24/addedAssets';
import type { CatalogItem } from '../../../../redux/api/fymAPI.types';
import type { AddAssetRequest, AddAssetTab } from './addAssetDialogStore';

/** The dialog request of a catalog row: the song title, the release day and the master length. Pure. */
export function addAssetRequestOf(
  accountId: number,
  item: Pick<CatalogItem, 'uuid' | 'title' | 'releaseDate' | 'song'>,
  themeId: AddedAssetTheme,
  tab?: AddAssetTab
): AddAssetRequest {
  return {
    accountId,
    catalogItemUuid: item.uuid,
    songTitle: item.title,
    releaseDate: item.releaseDate === null ? null : item.releaseDate.slice(0, 10),
    songDurationSec: item.song.durationSec,
    themeId,
    tab,
  };
}
